export default __webpack_public_path__ + "static/media/job.35c88d2c.png";